// uses youtube iframe API to play video

import * as _ from "underscore";

let initialised = false;
let options;
let player;
let enabled = true;

const onPlayerStateChange = (event) => {
  if (event.data === 1 || event.data === 2) {
    timeUpdate();
  } else if (event.data === 0) {
    if (options.onEnded) {
      options.onEnded();
    }
  } else if (event.data === 3) {
    if (options.onBuffering) {
      options.onBuffering();
    }
  }
  return;
};

const createPlayer = () => {
  enabled = true;
  if (player && options.playerElement.is("iframe")) {
    player.loadVideoById({
      videoId: options.youTubeID,
      startSeconds: options.start,
      endSeconds: options.end,
    });
    return;
  }

  const emittedOnReady = false;

  player = new window.YT.Player(options.playerElement.attr("id"), {
    width: options.playerElement.width(),
    videoId: options.youTubeID,
    events: {
      onReady: function () {
        //  $('iframe#mediaPlayer').addClass('needsclick');
        //          player.loadVideoById({
        //            videoId: options.youTubeID//,
        //            startSeconds: options.start,
        //            endSeconds: options.end
        //          });
      },
      onStateChange: function (state) {
        if (!emittedOnReady) {
          const duration = player.getDuration();
          if (duration > 0) {
            if (options.onReady) {
              options.onReady(player.getDuration());
            }
            // TODO: should we be setting this to true?
            //emittedOnReady;
          }
        }
        onPlayerStateChange(state);
      },
    },
    start: options.start,
    end: options.end,
    playerVars: { autoplay: 1, start: Math.round(options.start), rel: 0 },
  });
};

export const loadVideo = (_options) => {
  options = _options;

  if (!initialised) {
    // 2. This code loads the IFrame Player API code asynchronously.
    const tag = document.createElement("script");

    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    window.onYouTubeIframeAPIReady = () => {
      createPlayer();
    };
    initialised = true;
  } else {
    createPlayer();
  }
};

let updateTimer;
var timeUpdate = _.throttle(() => {
  if (!enabled) {
    return;
  }

  if (options.onTimeUpdate && player.getCurrentTime) {
    options.onTimeUpdate(player.getCurrentTime());
  }

  if (player.getPlayerState && player.getPlayerState() === 1) {
    clearTimeout(updateTimer);
    updateTimer = setTimeout(timeUpdate, 50);
  }
}, 50);

export const play = (time) => {
  enabled = true;
  if (time) {
    seekTo(time);
  }
  player.playVideo();
};

export const pause = () => {
  enabled = true;
  if (player) {
    player.pauseVideo();
  }
};

export const status = () => {
  if (!player || !player.getPlayerState) {
    return {
      paused: true,
    };
  }

  if (player.getPlayerState() === 1) {
    return {
      playing: true,
    };
  } else {
    return {
      paused: true,
    };
  }
};

export const disable = () => {
  enabled = false;
};

// var getDuration = function () {
//   return player.getDuration();
// };

export const reset = () => {
  disable();
  player = null;
};

export const jumpBack = (time) => {
  time = time || 5;
  seekTo(Math.max(0, player.getCurrentTime() - time));
};

export const jumpForward = (time) => {
  time = time || 5;
  seekTo(player.getCurrentTime() + time);
};

var seekTo = _.throttle((time) => {
  player.seekTo(time);
}, 200);

export const setSpeed = (speed) => player.setPlaybackRate(speed);

let slowSpeed = false;
export const toggleSpeed = () => {
  if (slowSpeed) {
    setSpeed(1);
  } else {
    setSpeed(0.5);
  }
  slowSpeed = !slowSpeed;
};
